export enum ClientsAlerts {
    USER_ALREDY_EXISTS = "clients.alerts.userAlreadyExists",
    REGISTER_SUCCESS = "clients.alerts.registerSuccess",
    CHOSE_ORDER_TYPE = "clients.alerts.choseOrderType"
}